import styled from 'styled-components'
import SVG from 'react-inlinesvg'
import { Text } from 'components/Text'

export const BillingInformationContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const BillingCards = styled.div`
  display: flex;;
  position: absolute;
  top: 15px;
  right: 22px;
`

export const BillingCardLogo = styled(SVG)<{ active: boolean }>`
  opacity: ${({ active }) => (active ? 1 : 0.35)};
  height: 46px;
  width: 46px;
`

export const BillingCardCardError = styled.span`
  color: ${({ theme }) => theme.colors.secondary};
`

export const BillingInformationCardContainer = styled.div`
  padding: 17px 39px;
  margin-top: 0px;
  padding-top: 0px;
`

export const BillingInformationCardTitle = styled(Text)`
  color: ${({ theme }) => theme.colors.primary};
`
export const BillingInformationContainerContent = styled.div`
  width: 50%;
`
export const BillingInformationRightContainerContent = styled.div`
  display: flex;
`

export const BillingInformationPayment = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`